/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaVnfSecuredConfiguration } from '../shiva-vnf-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AuthSupport } from '../models/auth-support';
import { AuthSupportSyncList } from '../models/auth-support-sync-list';
import { changeAuthSupportsStateVnf } from '../fn/vnf-authorization-supports/change-auth-supports-state-vnf';
import { ChangeAuthSupportsStateVnf$Params } from '../fn/vnf-authorization-supports/change-auth-supports-state-vnf';
import { createAuthSupportVnf } from '../fn/vnf-authorization-supports/create-auth-support-vnf';
import { CreateAuthSupportVnf$Params } from '../fn/vnf-authorization-supports/create-auth-support-vnf';
import { deleteAuthSupportVnf } from '../fn/vnf-authorization-supports/delete-auth-support-vnf';
import { DeleteAuthSupportVnf$Params } from '../fn/vnf-authorization-supports/delete-auth-support-vnf';
import { getAuthSupportSyncVnf } from '../fn/vnf-authorization-supports/get-auth-support-sync-vnf';
import { GetAuthSupportSyncVnf$Params } from '../fn/vnf-authorization-supports/get-auth-support-sync-vnf';
import { getAuthSupportVnf } from '../fn/vnf-authorization-supports/get-auth-support-vnf';
import { GetAuthSupportVnf$Params } from '../fn/vnf-authorization-supports/get-auth-support-vnf';
import { syncAuthSupportVnf } from '../fn/vnf-authorization-supports/sync-auth-support-vnf';
import { SyncAuthSupportVnf$Params } from '../fn/vnf-authorization-supports/sync-auth-support-vnf';
import { updateAuthSupportVnf } from '../fn/vnf-authorization-supports/update-auth-support-vnf';
import { UpdateAuthSupportVnf$Params } from '../fn/vnf-authorization-supports/update-auth-support-vnf';


/**
 * All about the VNF authorization management
 */
@Injectable({ providedIn: 'root' })
export class VnfAuthorizationSupportsService extends BaseService {
  constructor(config: ShivaVnfSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createAuthSupportVnf()` */
  static readonly CreateAuthSupportVnfPath = '/custom/auth-supports';

  /**
   * Create a VNF auth support.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAuthSupportVnf()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAuthSupportVnf$Response(params: CreateAuthSupportVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createAuthSupportVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a VNF auth support.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createAuthSupportVnf$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAuthSupportVnf(params: CreateAuthSupportVnf$Params, context?: HttpContext): Observable<void> {
    return this.createAuthSupportVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAuthSupportVnf()` */
  static readonly GetAuthSupportVnfPath = '/custom/auth-supports/{uid}';

  /**
   * get a VNF auth support.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuthSupportVnf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupportVnf$Response(params: GetAuthSupportVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupport>> {
    return getAuthSupportVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * get a VNF auth support.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuthSupportVnf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupportVnf(params: GetAuthSupportVnf$Params, context?: HttpContext): Observable<AuthSupport> {
    return this.getAuthSupportVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthSupport>): AuthSupport => r.body)
    );
  }

  /** Path part for operation `updateAuthSupportVnf()` */
  static readonly UpdateAuthSupportVnfPath = '/custom/auth-supports/{uid}';

  /**
   * Update a VNF auth support.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAuthSupportVnf()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAuthSupportVnf$Response(params: UpdateAuthSupportVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateAuthSupportVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Update a VNF auth support.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateAuthSupportVnf$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAuthSupportVnf(params: UpdateAuthSupportVnf$Params, context?: HttpContext): Observable<void> {
    return this.updateAuthSupportVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteAuthSupportVnf()` */
  static readonly DeleteAuthSupportVnfPath = '/custom/auth-supports/{uid}';

  /**
   * Delete a VNF auth support.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteAuthSupportVnf()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAuthSupportVnf$Response(params: DeleteAuthSupportVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteAuthSupportVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete a VNF auth support.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteAuthSupportVnf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteAuthSupportVnf(params: DeleteAuthSupportVnf$Params, context?: HttpContext): Observable<void> {
    return this.deleteAuthSupportVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getAuthSupportSyncVnf()` */
  static readonly GetAuthSupportSyncVnfPath = '/custom/auth-supports/sync';

  /**
   * Get the last 10 syncs details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAuthSupportSyncVnf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupportSyncVnf$Response(params?: GetAuthSupportSyncVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthSupportSyncList>> {
    return getAuthSupportSyncVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the last 10 syncs details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAuthSupportSyncVnf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAuthSupportSyncVnf(params?: GetAuthSupportSyncVnf$Params, context?: HttpContext): Observable<AuthSupportSyncList> {
    return this.getAuthSupportSyncVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<AuthSupportSyncList>): AuthSupportSyncList => r.body)
    );
  }

  /** Path part for operation `syncAuthSupportVnf()` */
  static readonly SyncAuthSupportVnfPath = '/custom/auth-supports/sync';

  /**
   * Start synchronize the VNF auth supports with the PLC.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `syncAuthSupportVnf()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncAuthSupportVnf$Response(params?: SyncAuthSupportVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return syncAuthSupportVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Start synchronize the VNF auth supports with the PLC.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `syncAuthSupportVnf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  syncAuthSupportVnf(params?: SyncAuthSupportVnf$Params, context?: HttpContext): Observable<void> {
    return this.syncAuthSupportVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `changeAuthSupportsStateVnf()` */
  static readonly ChangeAuthSupportsStateVnfPath = '/custom/auth-supports/state';

  /**
   * Change the state of a list of Auth Supports VNF, if newState is REMOVED, supports will be removed from PLC after next sync.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeAuthSupportsStateVnf()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeAuthSupportsStateVnf$Response(params: ChangeAuthSupportsStateVnf$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return changeAuthSupportsStateVnf(this.http, this.rootUrl, params, context);
  }

  /**
   * Change the state of a list of Auth Supports VNF, if newState is REMOVED, supports will be removed from PLC after next sync.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeAuthSupportsStateVnf$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeAuthSupportsStateVnf(params: ChangeAuthSupportsStateVnf$Params, context?: HttpContext): Observable<void> {
    return this.changeAuthSupportsStateVnf$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
